export { default } from './IntentToProceedCard';
